// src/store/reducers/claimprocedure.reducer.ts
import { createSlice } from '@reduxjs/toolkit'
import {
  fetchAllClaimProcedures,
  addClaimProcedure,
  updateClaimProcedure,
  deleteClaimProcedure,
} from '@store/actions/claimprocedure.action'
import { Procedure } from '@dataTypes/claimManagement.types'
import procedureData from '@assets/mockdata/Claims/procedureData'

export type ProcedureState = {
  procedures: Procedure[]
  loading: boolean
  error: string | null
}

const initialState: ProcedureState = {
  procedures: procedureData,
  loading: false,
  error: null,
}

const claimProcedureSlice = createSlice({
  name: 'claimProcedure',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllClaimProcedures.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAllClaimProcedures.fulfilled, (state, action) => {
        state.loading = false
        state.procedures = action.payload
      })
      .addCase(fetchAllClaimProcedures.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch procedures'
      })

      .addCase(addClaimProcedure.fulfilled, (state, action) => {
        state.procedures.push(action.payload)
      })
      .addCase(addClaimProcedure.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to add procedure'
      })

      .addCase(updateClaimProcedure.fulfilled, (state, action) => {
        const { procedureCode, updatedProcedure } = action.payload
        state.procedures = state.procedures.map((procedure) =>
          procedure.procedureCode === procedureCode
            ? { ...procedure, ...updatedProcedure }
            : procedure,
        )
      })
      .addCase(updateClaimProcedure.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to update procedure'
      })

      .addCase(deleteClaimProcedure.fulfilled, (state, action) => {
        state.procedures = state.procedures.filter(
          (procedure) => procedure.procedureCode !== action.payload,
        )
      })
      .addCase(deleteClaimProcedure.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to delete procedure'
      })
  },
})

export const { clearError } = claimProcedureSlice.actions
export default claimProcedureSlice.reducer
